export const london = {
  bearing: -45,
  latitude: 51.50,
  longitude: -0.077,
  pitch: 60,
  zoom: 13,
};